/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import ImgBanner from 'assets/images/img-banner-in-sample.svg';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { PanelState } from 'store/modules/panel_store/types';
import { Container } from './styles';

const TopBannerInSample = () => {
  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);

  return (
    <Container className="py-md-0 py-4 fixed-top w-100 bg-banner-in-sample">
      <div className="container">
        <div className="row">
          <div className="col-12 p-0 text-md-left text-center m-auto d-md-flex d-block align-items-center justify-content-around">
            <img className="d-md-block d-none" src={ImgBanner} alt="Assine agora" />
            <div>
              <h3>Adquira já a plataforma mais completa do mercado de Licitações</h3>
              <p>Não perca tempo! Assine agora e aproveite todos os nossos benefícios.</p>
            </div>
            <a
              className="btn btn-lg btn-in-sample"
              href={`${panel?.registration_type_validation === 1 ? '/cadastrar' : '/planos'}`}
            >
              Assinar agora
            </a>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default TopBannerInSample;
